// Mental health educational hub — topic clusters
export const TOPIC_LIST = [
  { id: "Kecemasan", en: "Anxiety", slug: { id: "kecemasan", en: "anxiety" }, hasPage: true },
  { id: "Stres", en: "Stress", slug: { id: "stres", en: "stress" }, hasPage: true },
  { id: "Burnout", en: "Burnout", slug: { id: "burnout", en: "burnout" }, hasPage: true },
  { id: "Trauma", en: "Trauma", slug: { id: "trauma", en: "trauma" }, hasPage: true },
  { id: "Kepercayaan Diri", en: "Self-Esteem", slug: { id: "kepercayaan-diri", en: "self-esteem" }, hasPage: true },
  { id: "Konflik Keluarga", en: "Family Conflict", slug: { id: "konflik-keluarga", en: "family-conflict" }, hasPage: true },
  { id: "Kesulitan Emosional", en: "Emotional Difficulties" },
  { id: "Masalah Hubungan", en: "Relationship Problems" },
  { id: "Kekhawatiran Pengasuhan", en: "Parenting Concerns" },
  { id: "Perilaku Anak", en: "Child Behavioral Concerns" },
  { id: "Tantangan Remaja", en: "Adolescent Challenges" },
  { id: "Transisi Kehidupan", en: "Life Transitions" },
  { id: "Stres Kerja", en: "Work-Related Stress" },
  { id: "Persiapan Pernikahan", en: "Premarital Concerns" },
  { id: "Kesulitan Pernikahan", en: "Marriage Difficulties" },
  { id: "Pengembangan Diri", en: "Personal Development" },
];

export const TOPIC_PAGES = {
  kecemasan: {
    slug: { id: "kecemasan", en: "anxiety" },
    title: { id: "Kecemasan", en: "Anxiety" },
    question: { id: "Seperti apa rasanya kecemasan?", en: "What does anxiety feel like?" },
    answer: {
      id: "Kecemasan adalah respons alami tubuh terhadap ancaman atau tekanan. Ia menjadi masalah ketika rasa khawatir terasa berlebihan, sulit dikendalikan, dan mulai mengganggu tidur, pekerjaan, atau hubungan Anda. Kecemasan yang berkepanjangan dapat ditangani dengan dukungan psikologis yang tepat.",
      en: "Anxiety is the body's natural response to threat or pressure. It becomes a problem when worry feels excessive, hard to control, and starts interfering with your sleep, work or relationships. Persistent anxiety can be addressed with appropriate psychological support.",
    },
    signs: {
      id: ["Khawatir berlebihan yang sulit dihentikan", "Jantung berdebar, otot tegang, atau sulit bernapas", "Sulit tidur atau sulit berkonsentrasi", "Menghindari situasi tertentu", "Mudah lelah dan gelisah"],
      en: ["Excessive worry that is hard to stop", "Racing heart, muscle tension or shortness of breath", "Trouble sleeping or concentrating", "Avoiding certain situations", "Fatigue and restlessness"],
    },
    whenToSeek: {
      id: "Pertimbangkan bertemu psikolog jika kecemasan berlangsung lebih dari beberapa minggu, terasa semakin berat, atau mulai membatasi aktivitas Anda sehari-hari.",
      en: "Consider seeing a psychologist if anxiety lasts more than a few weeks, feels increasingly heavy, or starts limiting your daily activities.",
    },
    serviceKey: "individual",
  },
  stres: {
    slug: { id: "stres", en: "stress" },
    title: { id: "Stres", en: "Stress" },
    question: { id: "Kapan stres perlu ditangani secara profesional?", en: "When does stress need professional support?" },
    answer: {
      id: "Stres adalah reaksi normal terhadap tuntutan hidup. Stres perlu ditangani secara profesional ketika berlangsung terus-menerus, memengaruhi kesehatan fisik, emosi, atau hubungan, dan strategi mandiri tidak lagi cukup membantu.",
      en: "Stress is a normal reaction to life's demands. Stress warrants professional support when it becomes persistent, affects your physical health, emotions or relationships, and self-help strategies are no longer enough.",
    },
    signs: {
      id: ["Merasa kewalahan hampir setiap hari", "Gangguan tidur atau nafsu makan", "Mudah marah atau sensitif", "Keluhan fisik seperti sakit kepala atau tegang otot", "Sulit menikmati hal yang biasanya menyenangkan"],
      en: ["Feeling overwhelmed most days", "Sleep or appetite disruption", "Irritability", "Physical complaints like headaches or muscle tension", "Difficulty enjoying things you usually like"],
    },
    whenToSeek: {
      id: "Jika stres bertahan berminggu-minggu atau mulai memengaruhi pekerjaan, kesehatan, dan hubungan Anda, konsultasi dengan psikolog dapat membantu menemukan strategi yang efektif.",
      en: "If stress lasts for weeks or begins affecting your work, health and relationships, consulting a psychologist can help you find effective strategies.",
    },
    serviceKey: "individual",
  },
  burnout: {
    slug: { id: "burnout", en: "burnout" },
    title: { id: "Burnout", en: "Burnout" },
    question: { id: "Apa perbedaan stres dan burnout?", en: "What is the difference between stress and burnout?" },
    answer: {
      id: "Stres umumnya ditandai keterlibatan berlebih dan energi yang menegang, sedangkan burnout ditandai kelelahan mendalam, jarak emosional dari pekerjaan, dan perasaan tidak efektif. Burnout berkembang perlahan akibat stres berkepanjangan yang tidak terkelola.",
      en: "Stress is generally marked by over-engagement and heightened energy, while burnout is marked by deep exhaustion, emotional distance from work, and a sense of ineffectiveness. Burnout develops gradually from prolonged, unmanaged stress.",
    },
    signs: {
      id: ["Kelelahan yang tidak hilang dengan istirahat", "Merasa sinis atau berjarak dari pekerjaan", "Menurunnya performa dan motivasi", "Merasa hampa atau tidak berdaya"],
      en: ["Exhaustion that rest does not fix", "Cynicism or detachment from work", "Declining performance and motivation", "Feeling empty or helpless"],
    },
    whenToSeek: {
      id: "Jika kelelahan dan kehilangan motivasi bertahan meski sudah beristirahat, pendampingan psikologis dapat membantu Anda memulihkan energi dan menata ulang prioritas.",
      en: "If exhaustion and loss of motivation persist despite rest, psychological support can help you recover energy and reset priorities.",
    },
    serviceKey: "individual",
  },
  trauma: {
    slug: { id: "trauma", en: "trauma" },
    title: { id: "Trauma", en: "Trauma" },
    question: { id: "Bagaimana trauma memengaruhi kehidupan sehari-hari?", en: "How does trauma affect daily life?" },
    answer: {
      id: "Trauma adalah respons psikologis terhadap peristiwa yang sangat menekan. Dampaknya dapat berupa ingatan yang mengganggu, kewaspadaan berlebih, penghindaran, dan perubahan suasana hati yang memengaruhi hubungan, pekerjaan, dan rasa aman sehari-hari.",
      en: "Trauma is a psychological response to deeply distressing events. Its effects can include intrusive memories, hypervigilance, avoidance and mood changes that affect relationships, work and everyday sense of safety.",
    },
    signs: {
      id: ["Ingatan atau mimpi buruk yang berulang", "Menghindari tempat, orang, atau situasi tertentu", "Merasa selalu waspada atau mudah terkejut", "Perubahan emosi yang signifikan setelah suatu peristiwa"],
      en: ["Recurring memories or nightmares", "Avoiding certain places, people or situations", "Feeling constantly on guard or easily startled", "Significant emotional changes after an event"],
    },
    whenToSeek: {
      id: "Jika dampak peristiwa masa lalu masih terasa setelah beberapa minggu atau mengganggu fungsi sehari-hari, konseling trauma dengan psikolog dapat membantu proses pemulihan secara aman.",
      en: "If the effects of a past event persist after several weeks or interfere with daily functioning, trauma counseling with a psychologist can support safe recovery.",
    },
    serviceKey: "trauma",
  },
  "kepercayaan-diri": {
    slug: { id: "kepercayaan-diri", en: "self-esteem" },
    title: { id: "Kepercayaan Diri", en: "Self-Esteem" },
    question: { id: "Bagaimana cara membangun kepercayaan diri yang sehat?", en: "How can I build healthy self-esteem?" },
    answer: {
      id: "Kepercayaan diri yang sehat dibangun melalui pemahaman diri, pola pikir yang realistis, dan pengalaman keberhasilan bertahap. Ketika kritik diri terasa dominan dan menghambat kehidupan, pendampingan psikolog dapat membantu mengubah pola tersebut.",
      en: "Healthy self-esteem is built through self-understanding, realistic thinking patterns and gradual experiences of success. When self-criticism feels dominant and limiting, working with a psychologist can help shift those patterns.",
    },
    signs: {
      id: ["Kritik diri yang berlebihan", "Takut gagal hingga menghindari kesempatan", "Sulit menerima pujian atau umpan balik", "Membandingkan diri secara terus-menerus"],
      en: ["Excessive self-criticism", "Fear of failure leading to avoidance", "Difficulty accepting praise or feedback", "Constant self-comparison"],
    },
    whenToSeek: {
      id: "Jika keraguan diri menghambat pekerjaan, hubungan, atau keputusan penting, konseling individu dapat membantu membangun fondasi kepercayaan diri yang lebih kuat.",
      en: "If self-doubt is holding back your work, relationships or key decisions, individual counseling can help build a stronger foundation of confidence.",
    },
    serviceKey: "individual",
  },
  "konflik-keluarga": {
    slug: { id: "konflik-keluarga", en: "family-conflict" },
    title: { id: "Konflik Keluarga", en: "Family Conflict" },
    question: { id: "Kapan konflik keluarga memerlukan bantuan profesional?", en: "When does family conflict need professional help?" },
    answer: {
      id: "Konflik adalah bagian normal dari kehidupan keluarga. Bantuan profesional diperlukan ketika konflik terus berulang tanpa penyelesaian, komunikasi memburuk, atau konflik mulai memengaruhi kesejahteraan anggota keluarga, terutama anak-anak.",
      en: "Conflict is a normal part of family life. Professional help is needed when conflict keeps repeating without resolution, communication deteriorates, or the conflict begins affecting family members' wellbeing, especially children.",
    },
    signs: {
      id: ["Pertengkaran yang sama terus berulang", "Anggota keluarga saling menghindar", "Anak menunjukkan perubahan perilaku", "Komunikasi berubah menjadi saling menyalahkan"],
      en: ["The same arguments keep repeating", "Family members avoiding each other", "Children showing behavioral changes", "Communication turning into blame"],
    },
    whenToSeek: {
      id: "Jika upaya menyelesaikan konflik secara mandiri tidak berhasil, konseling keluarga menghadirkan pihak netral yang membantu setiap anggota merasa didengar.",
      en: "If attempts to resolve conflict on your own are not working, family counseling brings in a neutral professional who helps every member feel heard.",
    },
    serviceKey: "family",
  },
};

export const findTopic = (lang, slug) =>
  Object.values(TOPIC_PAGES).find((t) => t.slug[lang] === slug);
